import { aboutStats, brandPoints, siteInfo, testimonialList } from '@/mocks/buzz';

export default function About() {
  return (
    <section id="about" className="bg-surface scroll-mt-20 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="font-display text-3xl text-coral-500 md:text-4xl">关于我们</p>
            <h2 className="mt-2 text-2xl font-black leading-snug md:text-3xl">
              帮你把碎片时间，变成高效吃瓜时间
            </h2>
            <p className="mt-4 text-sm leading-7 text-ink-soft md:text-base">
              「{siteInfo.brand}」是一个面向大众的轻量娱乐快讯速览站点。我们相信，追热点不应该变成一种负担——只要
              一分钟，你也能优雅地补完今天所有值得知道的要闻。
            </p>
            <p className="mt-3 text-sm leading-7 text-ink-soft md:text-base">
              这里的每一条速览都坚持"先看全、再精简"：保留时间线与关键前提，剔除注水与标题党，把复杂信息压缩成
              真正有用的要点，让你在通勤、午休或睡前的碎片时间里，轻松做个合格的"课代表"。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {aboutStats.map((s) => (
                <div key={s.label} className="rounded-2xl border border-paper bg-card p-4 text-center">
                  <p className="font-display text-2xl text-leaf-500 md:text-3xl">{s.value}</p>
                  <p className="mt-1 text-xs text-ink-soft">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-black text-ink md:text-xl">我们能为你提供什么</h3>
            <div className="mt-5 grid gap-3 sm:grid-cols-2">
              {brandPoints.map((p) => (
                <div key={p.title} className="rounded-2xl border border-paper bg-card p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-coral-50 text-coral-600">
                    <i className={`text-lg ${p.icon}`} />
                  </span>
                  <h4 className="mt-3 text-sm font-bold text-ink md:text-base">{p.title}</h4>
                  <p className="mt-1.5 text-xs leading-5 text-ink-soft md:text-sm">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12">
          <h3 className="font-display text-2xl text-coral-500 md:text-3xl">他们说</h3>
          <div className="mt-5 grid gap-4 md:grid-cols-3">
            {testimonialList.map((t) => (
              <figure key={t.name} className="rounded-2xl border border-paper bg-card p-5">
                <div className="flex text-coral-400">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <span key={i} className="flex h-4 w-4 items-center justify-center">
                      <i className="text-xs ri-star-fill" />
                    </span>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-6 text-ink-soft">
                  &ldquo;{t.text}&rdquo;
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-leaf-100 text-leaf-600">
                    <i className="text-sm ri-user-line" />
                  </span>
                  <div>
                    <p className="text-xs font-bold text-ink">{t.name}</p>
                    <p className="text-xs text-ink-muted">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}